import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { StyleProp, ViewStyle, Image, ImageStyle } from 'react-native';

import { OEText } from '../../atoms/oe-text/oe-text';
import { mb, width, height } from '../../style-utils';

export enum SectionPlaceholderType {
  CHART = 'CHART',
  SEARCH = 'SEARCH',
}

export interface SectionPlaceholderProps {
  text: string;
  type?: SectionPlaceholderType;
  style?: StyleProp<ViewStyle>;
}

const ICON_SIZE = 200;

const getIcon = (type: SectionPlaceholderType) => {
  switch (type) {
    case SectionPlaceholderType.SEARCH:
      return require('../../assets/section-placeholder/search-placeholder-icon.png');
    case SectionPlaceholderType.CHART:
    default:
      return require('../../assets/section-placeholder/chart-placeholder-icon.png');
  }
};

export const SectionPlaceholder = ({
  text,
  style,
  type = SectionPlaceholderType.CHART,
}: SectionPlaceholderProps) => {
  return (
    <Container style={style}>
      <Image
        source={getIcon(type)}
        style={[mb(30), width(ICON_SIZE), height(ICON_SIZE)] as ImageStyle}
      />
      <OEText fontSize={16} fontFamily={secondaryFontFamily} textAlign="center">
        {text}
      </OEText>
    </Container>
  );
};

const Container = styled.View`
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.backgroundGraySecondary};
  padding: 70px;
  justify-content: center;
  align-items: center;
`;
